export default __webpack_public_path__ + "static/media/lock-icon.0afdda85.svg";